module.exports = __webpack_public_path__ + "static/img/040_7.83162a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/040_7.jpg
// module id = nU5N
// module chunks = 1